import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

class OrderTime extends React.PureComponent {
    static propTypes = {
        expected_at: PropTypes.object,
        expected_in_string: PropTypes.string,
        is_expected_today: PropTypes.bool,
        t: PropTypes.func.isRequired,
    };

    render() {
        if (
            this.props.expected_at === null ||
            this.props.expected_in_string === null ||
            this.props.is_expected_today === null
        ) {
            return null;
        }
        const { t, expected_at } = this.props;
        return (
            <div
                className={`m2g-order-confirmation-expected-at${
                    this.props.is_expected_today
                        ? ' m2g-order-confirmation-expected-at--today'
                        : ''
                }`}
            >
                <label className="m2g-order-confirmation-label m2g-text--offset m2g-text--small">
                    {t('expected_at')}&nbsp;
                </label>
                <span data-time className="m2g-order-confirmation-time">
                    {t('expected_at_time', {
                        time: t('common:time', { time: expected_at }),
                    })}
                </span>
                <span data-date className="m2g-order-confirmation-date">
                    &nbsp;
                    {t('expected_at_date', { date: expected_at })}
                </span>
                <span className="m2g-order-confirmation-expected-in m2g-text--offset">
                    &nbsp;
                    <span data-in-string>
                        ({this.props.expected_in_string})
                    </span>
                </span>
            </div>
        );
    }
}

export default forwardRefWithTranslation('order.confirmation')(OrderTime);
